import AddWorkspaceModal from './AddWorkspaceModal'

export default AddWorkspaceModal
